var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"shrink-0 flex items-stretch border-b border-gray-200 | h-14 md:h-18"},[_c('div',{staticClass:"flex"},[_vm._t("left")],2),_c('h3',{class:[
            _vm.titleClassName,
            'grow flex items-center m-0 px-6 truncate font-semibold text-grey-650 text-lg | md:text-xl',
            'transition-all duration-300',
        ]},[_vm._t("default")],2),_c('div',{staticClass:"flex"},[_vm._t("right")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }